import { get, post, put } from "../Config";

export function SearchCustomer({ params }) {
  return get({ url: `/api/g99/v1/customer`, params });
}
export function GetCustomerByIds({ params, data }) {
  return post({ url: `/api/g99/v1/customerByIds`, params, data });
}

